import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { MessageCircle, Mail } from "lucide-react";
export default function CanalesDirectos() {
  return <section id="canales-directos" className="w-full bg-background py-20 md:py-24">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            O contáctanos directamente
          </h2>
          <p className="text-lg text-muted-foreground">
            Estamos disponibles para resolver tus dudas de forma rápida y sencilla.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {}
          <Link to="https://wa.me/56934141843?text=Hola NexoMayor, quiero agendar una evaluación para coordinar el cuidado de un familiar." newTab className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-xl">
            <Card className="h-full transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border-border/60 bg-card">
              <CardContent className="flex flex-col items-center justify-center p-10 md:p-12 gap-6 text-center h-full">
                <div className="p-5 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <MessageCircle className="size-12 md:size-14" strokeWidth={1.5} />
                </div>
                <div>
                  <span className="block text-2xl md:text-3xl font-semibold text-foreground mb-2">+(56) 934141843</span>
                  <span className="text-base md:text-lg text-muted-foreground">
                    Vía WhatsApp
                  </span>
                </div>
              </CardContent>
            </Card>
          </Link>

          {}
          <Link to="mailto:contacto@nexomayor.cl" className="block group outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-xl">
            <Card className="h-full transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border-border/60 bg-card">
              <CardContent className="flex flex-col items-center justify-center p-10 md:p-12 gap-6 text-center h-full">
                <div className="p-5 rounded-full bg-secondary text-secondary-foreground group-hover:bg-foreground group-hover:text-background transition-colors duration-300">
                  <Mail className="size-12 md:size-14" strokeWidth={1.5} />
                </div>
                <div>
                  <span className="block text-2xl md:text-3xl font-semibold text-foreground mb-2">
                    contacto@nexomayor.cl
                  </span>
                  <span className="text-base md:text-lg text-muted-foreground">
                    Envíanos un correo
                  </span>
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>;
}